import { Qualification } from '@luminovo/api-contracts';
import { assertUnreachable } from '@luminovo/commons';

export function formatQualification(value: Qualification): string {
    switch (value) {
        case Qualification.DLA:
            return 'DLA';
        case Qualification.RadHard:
            return 'Rad-Hard';
        case Qualification.Space:
            return 'Space';
        case Qualification.UL:
            return 'UL';
        default:
            assertUnreachable(value);
    }
}
